module.exports = __webpack_public_path__ + "static/media/ar.03b53cb5.svg";